// App.js
import React from 'react';
import AppRoutes from 'Routes';

const App = () => {
  return (
    <div>
      <AppRoutes />
    </div>
  );
};

export default App;
